import script from "./FormatMonth.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormatMonth.vue?vue&type=script&setup=true&lang=ts"

import "./FormatMonth.vue?vue&type=style&index=0&id=be986da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be986da8"]])

export default __exports__